import { Grid, Skeleton, Typography } from '@mui/material';
import { IDraftCardHeader } from './types';
import LocationIcon from 'assets/icons/Location_icon_new.svg';
import { styles } from './styles';

export const DraftCardHeader = ({ name, location, createdAt, isLoading }: IDraftCardHeader) => {
  return (
    <Grid sx={styles.container}>
      <Grid sx={styles.left}>
        {isLoading ? (
          <Skeleton sx={{ width: '100px', height: '20px', transform: 'scale(1)' }} />
        ) : (
          <Typography sx={styles.projectNameTypo}>{name}</Typography>
        )}
        {isLoading ? (
          <Skeleton sx={{ width: '150px', height: '18px', transform: 'scale(1)' }} />
        ) : (
          <Grid sx={styles.locationContainer}>
            <LocationIcon />
            <Typography sx={styles.locationTypo}>{location}</Typography>
          </Grid>
        )}
      </Grid>
      {isLoading ? (
        <Skeleton sx={{ width: '92px', height: '18px', transform: 'scale(1)' }} />
      ) : (
        <Typography sx={styles.createdAtTypo}>{createdAt}</Typography>
      )}
    </Grid>
  );
};
